import { render, staticRenderFns } from "./ChecklistModal.vue?vue&type=template&id=20080462"
import script from "./ChecklistModal.vue?vue&type=script&lang=js"
export * from "./ChecklistModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports